import { ReactNode } from 'react';
import { AlertKeys } from './components/UI/Alert/Alert.types';
import { IAppointment } from './components/appointment/appointment';

export type PageObjTypes = {
    key: PageKeys;
    title: string;
    component: ReactNode;
};

export const enum PageKeys {
    error = 'error',
    transfer = 'transfer',
    appointment = 'appointment',
}

export type PageContextProps = {
    setPage: (newPage: PageKeys) => void;
    setAlert: (newPage: AlertKeys) => void;
    page: PageKeys;
    id: number;
    setId: (id: number) => void;
    setData: (data: IAppointment) => void;
    data: IAppointment;
    isModal: boolean;
    setIsModal: (isModal: boolean) => void;
    successMessage: string;
    setSuccessMessage: (successMessage: string) => void;
    errorMessage: string;
    setErrorMessage: (errorMessage: string) => void;
};
